import React, { useEffect, useState } from 'react'
import { Table, Col, Row, Card, message } from 'antd'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import inventorySrc from '../../inventorySrc'
import Utils from '../../../../utils/Utils'

function InventoryTable(props) {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)

  useEffect(() => {    
    const paginate = !!props.searchText || props.searchText === ''
    if (!props.keyTab || props.keyTab === '1') fetchInventory(paginate, props.searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedOption, props.searchText, props.keyTab, props.lowStock])

  const fetchInventory = (paginate, filter = '', lowStock=false) => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(filter)
    inventorySrc
      .getInventory(props.selectedOption, paginate, filter, props.lowStock, excludeChars, 'desc')
      .then(res => {
        if (res?.errors && Object.keys(res.errors)?.length > 0) {
          Utils.checkErrors(res)
          setLoading(false)
        } else {
          setDataSource(setInventory(res))
          setExistMoreInfo(res.data.next_page_url !== null)
          setNextPage(res.data.next_page_url)
          setLoading(false)
        }
      })
      .catch(e => {
        message.error('No se ha podido cargar el inventario.')
        setLoading(false)
      })
  }

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'product', // Field that is goint to be rendered
      key: 'product',
      render: text => <span style={{ textAlign: 'left' }}>{text ? text : 'Sin nombre'}</span>,
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity', // Field that is goint to be rendered
      key: 'quantity',
      render: text => <span>{text ? text : 'Sin cantidad'}</span>,
    },
    {
      title: 'Costo con Impuesto',
      dataIndex: 'avg_product_unit_cost', // Field that is goint to be rendered
      key: 'avg_product_unit_cost',
      render: text => <span>{text ? text : 'Sin cantidad'}</span>,
    },
    {
      title: 'Costo sin Impuesto',
      dataIndex: 'avg_with_taxes', // Field that is goint to be rendered
      key: 'avg_with_taxes',
      render: text => <span>{text ? text : 'Sin cantidad'}</span>,
    },
    {
      title: 'Última salida',
      dataIndex: 'last_output', // Field that is goint to be rendered
      key: 'last_output',
      render: text => <span>{text ? text : 'Sin salida'}</span>,
    },
    {
      title: 'Última entrada',
      dataIndex: 'last_input', // Field that is goint to be rendered
      key: 'last_input',
      render: text => <span>{text ? text : 'Sin entrada'}</span>,
    },
    {
      title: 'Último conteo',
      dataIndex: 'last_count', // Field that is goint to be rendered
      key: 'last_count',
      render: text => <span>{text ? text : 'Sin conteo'}</span>,
    },
  ]

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      inventorySrc.getNextPage(nextPage).then(response => {
        setDataSource(dataSource.concat(setInventory(response)))
        setExistMoreInfo(response.data.next_page_url !== null)
        setNextPage(response.data.next_page_url)
        setLoading(false)
      })
    }
  }

  const setInventory = inventory => {
    if (inventory !== 'Too Many Attempts.') {
      let _inventory = inventory.data.data || []
      return _inventory.map((d, i) => ({
        key: i,
        product_id: d.product_id,
        product: d.product_description,
        quantity: d.quantity,
        avg_product_unit_cost: d.avg_product_unit_cost,
        avg_with_taxes: d.avg_with_taxes,
        last_output: Utils.formatDate(d.last_output),
        last_input: Utils.formatDate(d.last_input),
        last_count: Utils.formatDate(d.last_count),
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table className={'CustomTableClass'} dataSource={dataSource} columns={columns} pagination={false} loading={loading} rowKey="key" />
                <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default InventoryTable
